import { render, staticRenderFns } from "./formEvents.vue?vue&type=template&id=93089d1a&"
import script from "./formEvents.vue?vue&type=script&lang=js&"
export * from "./formEvents.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports